import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { SectionDomain, SectionDomainSetting } from '../../models';

enum ActionType {
  Edit,
  Remove,
}

export const isSpace = (control: AbstractControl) => {
  const ret = (control.value || '').match(/\s/g);
  return ret && ret.length > 0 ? { whitespace: true } : null;
};

@Component({
  selector: 'apsis-back-office-sections-domain-add',
  templateUrl: './sections-domain-add.component.html',
  styleUrls: ['./sections-domain-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionsDomainAddComponent {
  @Input() sections: SectionDomain[] = [];
  @Input() selectedSectionsDomains: SectionDomainSetting[] = [];
  @Output() addSectionDomain = new EventEmitter<SectionDomainSetting>();
  @Output() removeSectionDomain = new EventEmitter<string>();
  @Output() selectSectionDomain = new EventEmitter<string>();

  public sectionControl: FormControl;
  public sectionDomainNameControl: FormControl;
  public ActionType = ActionType;

  constructor() {
    this.sectionControl = new FormControl('', Validators.required);
    this.sectionDomainNameControl = new FormControl('', [isSpace]);
  }

  addSection() {
    const { id, name } = this.sectionControl.value;
    this.addSectionDomain.emit({
      id,
      name,
      domainName: this.sectionDomainNameControl.value,
    });

    this.sectionControl.setValue('');
    this.sectionDomainNameControl.setValue('');
    this.sectionDomainNameControl.markAsPristine();
    this.sectionDomainNameControl.markAsUntouched();
  }

  selectSection(sectionId: string) {
    this.selectSectionDomain.emit(sectionId);
  }

  actionClick(sectionDomain: { actionType: ActionType; payload: string }) {
    this.removeSectionDomain.emit(sectionDomain.payload);
  }
}
